<nz-page-header nzTitle="Finance Home" nzSubtitle="" class="mb-3"></nz-page-header>

<div class="row mb-3">
	<div class="col">
		<nz-card>
			<nz-statistic nzTitle="Products" [nzValue]="products.length"></nz-statistic>
		</nz-card>
	</div>
	<div class="col">
		<nz-card>
			<nz-statistic nzTitle="Active Policies" [nzValue]="totalPolicyCount"></nz-statistic>
		</nz-card>
	</div>
	<div class="col">
		<nz-card>
			<nz-statistic nzTitle="Schedule Due" [nzValue]="scheduleDueCount" [nzValueStyle]="{ color: '#1890ff' }"></nz-statistic>
		</nz-card>
	</div>
	<div class="col">
		<nz-card>
			<nz-statistic nzTitle="Schedule Overdue" [nzValue]="scheduleOverdueCount" [nzValueStyle]="{ color: '#ff4d4f' }"></nz-statistic>
		</nz-card>
	</div>
	<div class="col">
		<nz-card>
			<nz-statistic nzTitle="Total Raised" [nzValue]="totalRaisedPremium" nzPrefix="R"></nz-statistic>
		</nz-card>
	</div>
	<div class="col">
		<nz-card>
			<nz-statistic nzTitle="Total Due" [nzValue]="totalDuePremium" nzPrefix="R"></nz-statistic>
		</nz-card>
	</div>
	<div class="col">
		<nz-card>
			<nz-statistic nzTitle="Total Outstanding" [nzValue]="totalOutstandingPremium" nzPrefix="R"
				[nzValueStyle]="{ color: totalOutstandingPremium > 0 ? '#ff4d4f' : 'inherit' }"></nz-statistic>
		</nz-card>
	</div>
</div>

<div class="row">
	<div class="col">
		<nz-table [nzData]="products" [nzFrontPagination]="false" [nzLoading]="loading">
			<thead>
				<tr>
					<th>Product ID</th>
					<th>Product Name</th>
					<th>Product Type</th>
					<th>Status</th>
					<th>Outstanding Premiums</th>
					<th>Premiums Raised</th>
					<th>Policy Count</th>
					<th>Last Schedule At</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let wrapper of products" (dblclick)="open(wrapper)">
					<td>{{wrapper.product.id}}</td>
					<td>{{wrapper.product.name}}</td>
					<td>{{wrapper.product.productType}}</td>
					<td>
						<nz-tag [nzColor]="getStatusColor(wrapper.status)">{{wrapper.status}}</nz-tag>
					</td>
					<td>{{wrapper.outstandingPremiums | currency:'ZAR':'symbol-narrow'}}</td>
					<td>{{wrapper.raisedPremium | currency:'ZAR':'symbol-narrow'}}</td>
					<td>{{wrapper.policyCount|number}}</td>
					<td>{{(wrapper.lastSchedulePolicyPremiumRaisedDate|date)??'Never'}}</td>
				</tr>
			</tbody>
		</nz-table>
	</div>
</div>
